import { __require as requireFunctionCall } from './node_modules-core-js-internals-function-call.js';
import { __require as requireHasOwnProperty } from './node_modules-core-js-internals-has-own-property.js';
import { __require as requireObjectIsPrototypeOf } from './node_modules-core-js-internals-object-is-prototype-of.js';
import { __require as requireRegexpFlagsDetection } from './node_modules-core-js-internals-regexp-flags-detection.js';
import { __require as requireRegexpFlags } from './node_modules-core-js-internals-regexp-flags.js';

var regexpGetFlags;
var hasRequiredRegexpGetFlags;

function requireRegexpGetFlags () {
	if (hasRequiredRegexpGetFlags) return regexpGetFlags;
	hasRequiredRegexpGetFlags = 1;
	var call = requireFunctionCall();
	var hasOwn = requireHasOwnProperty();
	var isPrototypeOf = requireObjectIsPrototypeOf();
	var regExpFlagsDetection = requireRegexpFlagsDetection();
	var regExpFlagsGetterImplementation = requireRegexpFlags();

	var RegExpPrototype = RegExp.prototype;

	regexpGetFlags = regExpFlagsDetection.correct ? function (it) {
	  return it.flags;
	} : function (it) {
	  return (!regExpFlagsDetection.correct && isPrototypeOf(RegExpPrototype, it) && !hasOwn(it, 'flags'))
	    ? call(regExpFlagsGetterImplementation, it)
	    : it.flags;
	};
	return regexpGetFlags;
}

export { requireRegexpGetFlags as __require };
//# sourceMappingURL=node_modules-core-js-internals-regexp-get-flags.js.map
